import type { IdeaSource } from './types';

/** Ideenbuch 21–30: from the hand, from the tray, soups and curries. */
export const IDEAS_3: IdeaSource[] = [
  {
    id: 'chicken-wraps',
    minutes: 20,
    tags: ['kids'],
    de: {
      title: 'Wraps mit Hähnchen und Gemüse',
      ingredients: [
        '8 Wraps',
        '400 g Hähnchenbrust',
        '1 Gurke',
        '2 Tomaten',
        '1 Salat',
        '150 g Joghurt',
        '1 TL Paprikapulver',
      ],
      steps: [
        'Hähnchen in Streifen schneiden, mit Paprikapulver und Salz würzen und 8 Minuten braten.',
        'Gurke, Tomaten und Salat klein schneiden.',
        'Wraps kurz erwärmen, mit Joghurt bestreichen und füllen.',
      ],
      kidsTip: 'Alles in Schälchen auf den Tisch – jeder baut seinen Wrap selbst.',
    },
    en: {
      title: 'Chicken and vegetable wraps',
      ingredients: [
        '8 wraps',
        '400 g chicken breast',
        '1 cucumber',
        '2 tomatoes',
        '1 lettuce',
        '150 g yoghurt',
        '1 tsp paprika',
      ],
      steps: [
        'Cut the chicken into strips, season with paprika and salt and fry for 8 minutes.',
        'Chop the cucumber, tomatoes and lettuce.',
        'Warm the wraps briefly, spread with yoghurt and fill.',
      ],
      kidsTip: 'Everything in little bowls on the table – everyone builds their own.',
    },
  },
  {
    id: 'quesadillas',
    minutes: 20,
    tags: ['veggie', 'kids'],
    de: {
      title: 'Quesadillas mit Käse und Mais',
      ingredients: [
        '8 Tortillas',
        '250 g geriebener Käse',
        '1 Dose Mais',
        '1 Dose Kidneybohnen',
        '1 Paprika, fein gewürfelt',
        '150 g Schmand',
      ],
      steps: [
        'Mais und Bohnen abtropfen lassen und mit der Paprika mischen.',
        'Vier Tortillas mit Käse und Gemüse belegen und mit den übrigen Tortillas abdecken.',
        'In einer Pfanne ohne Fett von jeder Seite 3 Minuten braten, bis der Käse schmilzt.',
        'In Ecken schneiden und mit Schmand servieren.',
      ],
      kidsTip: 'Nur Käse hinein geht immer.',
    },
    en: {
      title: 'Cheese and sweetcorn quesadillas',
      ingredients: [
        '8 tortillas',
        '250 g grated cheese',
        '1 can sweetcorn',
        '1 can kidney beans',
        '1 pepper, finely diced',
        '150 g soured cream',
      ],
      steps: [
        'Drain the sweetcorn and beans and mix with the pepper.',
        'Top four tortillas with cheese and vegetables and cover with the other tortillas.',
        'Cook in a dry pan for 3 minutes on each side until the cheese melts.',
        'Cut into wedges and serve with soured cream.',
      ],
      kidsTip: 'Cheese only always works.',
    },
  },
  {
    id: 'burgers',
    minutes: 35,
    tags: ['kids'],
    de: {
      title: 'Burger selbst gemacht',
      ingredients: [
        '500 g Rinderhackfleisch',
        '4 Burgerbrötchen',
        '4 Scheiben Käse',
        '2 Tomaten',
        '1 Salat',
        '1 rote Zwiebel',
        'Ketchup und Senf',
      ],
      steps: [
        'Hack mit Salz und Pfeffer würzen und vier flache Patties formen.',
        'In einer heißen Pfanne von jeder Seite 4 Minuten braten, zum Schluss Käse darauflegen.',
        'Brötchen aufschneiden und kurz rösten.',
        'Tomaten und Zwiebel in Scheiben schneiden und alles zusammen auf den Tisch stellen.',
      ],
      kidsTip: 'Burgerabend: jeder belegt selbst.',
    },
    en: {
      title: 'Homemade burgers',
      ingredients: [
        '500 g beef mince',
        '4 burger buns',
        '4 slices cheese',
        '2 tomatoes',
        '1 lettuce',
        '1 red onion',
        'Ketchup and mustard',
      ],
      steps: [
        'Season the mince with salt and pepper and shape four flat patties.',
        'Fry in a hot pan for 4 minutes on each side, laying the cheese on top at the end.',
        'Halve the buns and toast them briefly.',
        'Slice the tomatoes and onion and put everything on the table.',
      ],
      kidsTip: 'Burger night: everyone builds their own.',
    },
  },
  {
    id: 'tray-pizza',
    minutes: 50,
    tags: ['veggie', 'kids'],
    de: {
      title: 'Pizza vom Blech',
      ingredients: [
        '1 Rolle Pizzateig (Kühlregal)',
        '200 g passierte Tomaten',
        '1 TL Oregano',
        '250 g Mozzarella',
        '1 Paprika',
        '100 g Champignons',
        '1 Dose Mais',
      ],
      steps: [
        'Ofen auf 220 °C vorheizen und den Teig auf einem Blech ausrollen.',
        'Tomaten mit Oregano und Salz verrühren und auf den Teig streichen.',
        'Mit Mozzarella und Gemüse belegen.',
        '15 Minuten backen, bis der Rand goldbraun ist.',
      ],
      kidsTip: 'Jedes Kind belegt sein eigenes Viertel.',
    },
    en: {
      title: 'Tray pizza',
      ingredients: [
        '1 roll pizza dough (chilled)',
        '200 g passata',
        '1 tsp oregano',
        '250 g mozzarella',
        '1 pepper',
        '100 g mushrooms',
        '1 can sweetcorn',
      ],
      steps: [
        'Heat the oven to 220 °C and roll the dough out on a tray.',
        'Mix the passata with oregano and salt and spread it on the dough.',
        'Top with mozzarella and vegetables.',
        'Bake for 15 minutes until the edge is golden.',
      ],
      kidsTip: 'Each child tops their own quarter.',
    },
  },
  {
    id: 'flammkuchen',
    minutes: 30,
    tags: [],
    de: {
      title: 'Flammkuchen',
      ingredients: [
        '1 Rolle Flammkuchenteig (Kühlregal)',
        '200 g Schmand',
        '150 g Speckwürfel',
        '2 Zwiebeln, in feinen Ringen',
        '1 Prise Muskat',
      ],
      steps: [
        'Ofen auf 220 °C vorheizen und den Teig auf einem Blech ausrollen.',
        'Schmand mit Salz, Pfeffer und Muskat verrühren und dünn aufstreichen.',
        'Mit Zwiebelringen und Speck belegen.',
        '12 Minuten backen, bis der Rand knusprig ist.',
      ],
      kidsTip: 'Eine Hälfte ohne Zwiebeln lassen.',
    },
    en: {
      title: 'Tarte flambée',
      ingredients: [
        '1 roll tarte flambée dough (chilled)',
        '200 g soured cream',
        '150 g diced bacon',
        '2 onions, in thin rings',
        '1 pinch nutmeg',
      ],
      steps: [
        'Heat the oven to 220 °C and roll the dough out on a tray.',
        'Mix the soured cream with salt, pepper and nutmeg and spread it thinly.',
        'Top with the onion rings and bacon.',
        'Bake for 12 minutes until the edge is crisp.',
      ],
      kidsTip: 'Leave one half without onions.',
    },
  },
  {
    id: 'veg-coconut-curry',
    minutes: 30,
    tags: ['veggie'],
    de: {
      title: 'Gemüsecurry mit Kokosmilch',
      ingredients: [
        '250 g Reis',
        '1 Brokkoli',
        '2 Möhren',
        '1 Paprika',
        '1 Dose Kichererbsen',
        '1 Dose Kokosmilch',
        '2 EL gelbe Currypaste',
        '1 EL Öl',
      ],
      steps: [
        'Reis nach Packung kochen.',
        'Currypaste in Öl kurz anrösten und mit Kokosmilch ablöschen.',
        'Gemüse klein schneiden, mit den abgespülten Kichererbsen dazugeben.',
        '12 Minuten köcheln lassen, bis das Gemüse gar ist, und mit Salz abschmecken.',
      ],
      kidsTip: 'Wenig Currypaste nehmen – nachwürzen geht am Tisch.',
    },
    en: {
      title: 'Vegetable curry with coconut milk',
      ingredients: [
        '250 g rice',
        '1 broccoli',
        '2 carrots',
        '1 pepper',
        '1 can chickpeas',
        '1 can coconut milk',
        '2 tbsp yellow curry paste',
        '1 tbsp oil',
      ],
      steps: [
        'Cook the rice as the packet says.',
        'Toast the curry paste briefly in the oil and pour in the coconut milk.',
        'Chop the vegetables and add them with the rinsed chickpeas.',
        'Simmer for 12 minutes until the vegetables are done and season with salt.',
      ],
      kidsTip: 'Go easy on the curry paste – more can go on at the table.',
    },
  },
  {
    id: 'pumpkin-soup',
    minutes: 40,
    tags: ['veggie'],
    de: {
      title: 'Kürbissuppe',
      ingredients: [
        '1 Hokkaido-Kürbis',
        '2 Kartoffeln',
        '1 Zwiebel',
        '1 Stück Ingwer',
        '1 l Gemüsebrühe',
        '200 ml Kokosmilch',
        'Kürbiskerne',
      ],
      steps: [
        'Kürbis entkernen und mit Schale würfeln, Kartoffeln und Zwiebel schälen und würfeln.',
        'Alles mit geriebenem Ingwer kurz andünsten und mit Brühe aufgießen.',
        '20 Minuten köcheln lassen und fein pürieren.',
        'Kokosmilch einrühren, abschmecken und mit Kürbiskernen servieren.',
      ],
      kidsTip: 'Croutons zum Drüberstreuen machen die Suppe spannend.',
    },
    en: {
      title: 'Pumpkin soup',
      ingredients: [
        '1 red kuri squash',
        '2 potatoes',
        '1 onion',
        '1 piece ginger',
        '1 l vegetable stock',
        '200 ml coconut milk',
        'Pumpkin seeds',
      ],
      steps: [
        'Deseed the squash and dice it with the skin on; peel and dice the potatoes and onion.',
        'Soften everything briefly with grated ginger and pour in the stock.',
        'Simmer for 20 minutes and blend until smooth.',
        'Stir in the coconut milk, season and serve with pumpkin seeds.',
      ],
      kidsTip: 'Croutons to sprinkle on make soup exciting.',
    },
  },
  {
    id: 'tomato-soup-toast',
    minutes: 25,
    tags: ['veggie', 'kids'],
    de: {
      title: 'Tomatensuppe mit Käsetoast',
      ingredients: [
        '2 Dosen gehackte Tomaten',
        '1 Zwiebel, gewürfelt',
        '500 ml Gemüsebrühe',
        '100 g Sahne',
        '8 Scheiben Toastbrot',
        '4 Scheiben Käse',
        '1 EL Butter',
      ],
      steps: [
        'Zwiebel in Butter andünsten, Tomaten und Brühe dazugeben und 15 Minuten köcheln lassen.',
        'Suppe pürieren, Sahne einrühren, mit Salz und Pfeffer abschmecken.',
        'Je zwei Toasts mit Käse belegen und in einer Pfanne von jeder Seite 3 Minuten goldbraun braten.',
        'Toasts in Streifen schneiden und zum Eintunken dazu reichen.',
      ],
      kidsTip: 'Toaststreifen zum Eintunken – das isst jeder.',
    },
    en: {
      title: 'Tomato soup with cheese toasties',
      ingredients: [
        '2 cans chopped tomatoes',
        '1 onion, diced',
        '500 ml vegetable stock',
        '100 g cream',
        '8 slices bread',
        '4 slices cheese',
        '1 tbsp butter',
      ],
      steps: [
        'Soften the onion in the butter, add the tomatoes and stock and simmer for 15 minutes.',
        'Blend the soup, stir in the cream and season with salt and pepper.',
        'Sandwich the cheese between pairs of bread and fry for 3 minutes on each side until golden.',
        'Cut the toasties into strips for dipping.',
      ],
      kidsTip: 'Toastie strips for dipping – everyone eats that.',
    },
  },
  {
    id: 'pea-risotto',
    minutes: 35,
    tags: ['veggie', 'kids'],
    de: {
      title: 'Erbsenrisotto',
      ingredients: [
        '300 g Risottoreis',
        '1 Zwiebel, fein gewürfelt',
        '1 l heiße Gemüsebrühe',
        '300 g TK-Erbsen',
        '50 g Parmesan, gerieben',
        '2 EL Butter',
      ],
      steps: [
        'Zwiebel in 1 EL Butter glasig dünsten, Reis dazugeben und kurz mitdünsten.',
        'Nach und nach heiße Brühe angießen und unter Rühren 20 Minuten garen.',
        'Erbsen die letzten 5 Minuten mitgaren.',
        'Parmesan und restliche Butter unterrühren und abschmecken.',
      ],
      kidsTip: 'Kinder dürfen rühren – Risotto braucht Geduld.',
    },
    en: {
      title: 'Pea risotto',
      ingredients: [
        '300 g risotto rice',
        '1 onion, finely diced',
        '1 l hot vegetable stock',
        '300 g frozen peas',
        '50 g Parmesan, grated',
        '2 tbsp butter',
      ],
      steps: [
        'Soften the onion in 1 tbsp butter, add the rice and stir briefly.',
        'Add the hot stock bit by bit and cook for 20 minutes, stirring.',
        'Add the peas for the last 5 minutes.',
        'Stir in the Parmesan and the rest of the butter and season.',
      ],
      kidsTip: 'Kids can do the stirring – risotto needs patience.',
    },
  },
  {
    id: 'gnocchi-spinach',
    minutes: 20,
    tags: ['veggie'],
    de: {
      title: 'Gnocchi-Pfanne mit Spinat',
      ingredients: [
        '800 g Gnocchi (Kühlregal)',
        '200 g Babyspinat',
        '250 g Cherrytomaten',
        '1 Knoblauchzehe',
        '100 g Sahne',
        '50 g Parmesan, gerieben',
        '2 EL Butter',
      ],
      steps: [
        'Gnocchi in Butter 8 Minuten goldbraun braten.',
        'Knoblauch und halbierte Tomaten dazugeben und 2 Minuten mitbraten.',
        'Spinat unterheben, bis er zusammenfällt.',
        'Sahne und Parmesan einrühren und mit Salz und Pfeffer abschmecken.',
      ],
      kidsTip: 'Spinat ganz klein schneiden oder für die Kinder weglassen.',
    },
    en: {
      title: 'Gnocchi pan with spinach',
      ingredients: [
        '800 g gnocchi (chilled)',
        '200 g baby spinach',
        '250 g cherry tomatoes',
        '1 clove garlic',
        '100 g cream',
        '50 g Parmesan, grated',
        '2 tbsp butter',
      ],
      steps: [
        'Fry the gnocchi in the butter for 8 minutes until golden.',
        'Add the garlic and halved tomatoes and fry for 2 minutes.',
        'Fold in the spinach until it wilts.',
        'Stir in the cream and Parmesan and season with salt and pepper.',
      ],
      kidsTip: 'Chop the spinach very small or leave it out for the kids.',
    },
  },
];
